import React, { useEffect, useState } from 'react'
import ModalComponent from '../../components/modal/ModalComponent'
import Text from '../../components/text/Text'
import { getPromotionProduct } from './../../services/promotions'
import moment from 'moment'
import styles from './../../views/payment/payment.module.css'
import { PromotionInfo } from './../../views/payment/payment'

interface PromotionModalProps {
    promotionInfo: PromotionInfo
    showPromotionModal: boolean
    setShowPromotionModal: (show: boolean) => void
    title: string
    marginLeftTitle: number
    btnCobrar: boolean
}

const PromotionModal: React.FC<PromotionModalProps> = ({
    promotionInfo,
    showPromotionModal,
    setShowPromotionModal,
    title,
    marginLeftTitle,
    btnCobrar
}) => {
    const daysOfWeek = [
        { day: 'LUN', active: promotionInfo?.bLunes === true },
        { day: 'MAR', active: promotionInfo?.bMartes === true },
        { day: 'MIER', active: promotionInfo?.bMiercoles === true },
        { day: 'JUE', active: promotionInfo?.bJueves === true },
        { day: 'VIE', active: promotionInfo?.bViernes === true },
        { day: 'SAB', active: promotionInfo?.bSabado === true },
        { day: 'DOM', active: promotionInfo?.bDomingo === true },
    ]

    const [productName, setProductName] = useState<string>('')

    useEffect(() => {
        const fetchProductName = async () => {
            if (
                promotionInfo?.idPromocion &&
                promotionInfo?.sTipo === 'DescuentoSKU'
            ) {
                const product = await getPromotionProduct(
                    promotionInfo.idPromocion
                )
                if (product && product.length > 0) {
                    setProductName(product[0].product.productName)
                }
            }
        }

        fetchProductName()
    }, [promotionInfo?.idPromocion])

    return (
        <ModalComponent
            show={showPromotionModal}
            handleClose={() => setShowPromotionModal(false)}
            modalStyle={styles.promotionModalStyle}
        >
            <div className={styles.modalContainer}>
                <Text
                    label={title}
                    fontSize={24}
                    fontWeight={600}
                    color={'#0086D6'}
                    marginLeft={marginLeftTitle}
                    marginTop={15}
                    marginBottom={20}
                />
                <div className={styles.flexDirectionPayment}>
                    <Text
                        label={'Nombre:'}
                        fontSize={14}
                        fontWeight={700}
                        color="#565656"
                        marginRight={8}
                        marginBottom={5}
                    />
                    <Text
                        label={promotionInfo?.sPromocion ?? ''}
                        fontSize={24}
                        fontWeight={600}
                        color={'#565656'}
                        marginBottom={5}
                        marginRight={20}
                    />
                </div>
                <div className={styles.flexDirectionPayment}>
                    <Text
                        label={'Tipo de\npromoción:'}
                        fontSize={10}
                        fontWeight={700}
                        color={'#565656'}
                        marginRight={8}
                        lineHeight={1}
                    />
                    {promotionInfo?.nDescuento === null &&
                    promotionInfo?.sTipo === 'DescuentoDelivery' ? (
                        <Text
                            label={`Desc. en delivery gratis`}
                            fontSize={10}
                            fontWeight={600}
                            color={'#565656'}
                            marginRight={30}
                        />
                    ) : (
                        <Text
                            label={`${promotionInfo?.nDescuento}% de DSCTO.`}
                            fontSize={10}
                            fontWeight={600}
                            color={'#565656'}
                            marginRight={30}
                        />
                    )}
                    <Text
                        label={'Detalle:'}
                        fontSize={10}
                        fontWeight={700}
                        color={'#565656'}
                        marginRight={8}
                    />
                    {promotionInfo?.nMontoMinimo === null &&
                    promotionInfo?.sTipo === 'DescuentoSKU' ? (
                        <Text
                            label={`Desc. producto: ${productName}`} //TODO: CONCATENAR PRODUCTO
                            fontSize={10}
                            fontWeight={600}
                            color={'#565656'}
                            lineHeight={1}
                        />
                    ) : (
                        <Text
                            label={`Monto mínimo de\ncompra para efectuar\nel descuento: $${promotionInfo?.nMontoMinimo}`}
                            fontSize={10}
                            fontWeight={600}
                            color={'#565656'}
                            lineHeight={1}
                        />
                    )}
                </div>
                {promotionInfo?.stock && (
                    <div
                        style={{ marginTop: 10 }}
                        className={styles.flexDirectionPayment}
                    >
                        <Text
                            label={'Stock:'}
                            fontSize={10}
                            fontWeight={700}
                            color={'#565656'}
                            marginRight={8}
                        />
                        <Text
                            label={String(promotionInfo?.stock ?? '')}
                            fontSize={10}
                            fontWeight={600}
                            color={'#565656'}
                            lineHeight={1}
                        />
                    </div>
                )}
                <div className={styles.line} />
                <Text
                    label={'Vigencia:'}
                    fontSize={16}
                    fontWeight={700}
                    color={'#565656'}
                    marginBottom={10}
                />
                <div className={styles.flexDirectionPayment}>
                    <Text
                        label={`Desde: ${promotionInfo?.dInicio}`}
                        fontSize={10}
                        fontWeight={700}
                        color={'#565656'}
                        marginRight={40}
                        marginBottom={10}
                    />
                    <Text
                        label={`Hasta: ${promotionInfo?.dTermino}`}
                        fontSize={10}
                        fontWeight={600}
                        color={'#565656'}
                        marginBottom={10}
                    />
                </div>
                <Text
                    label={'Días disponibles para promoción:'}
                    fontSize={16}
                    fontWeight={700}
                    color={'#565656'}
                />
                <div className={styles.flexDirectionPayment}>
                    {daysOfWeek.map((item, index) => (
                        <Text
                            key={index}
                            label={item.day}
                            fontSize={10}
                            fontWeight={900}
                            color={item.active ? '#2699D6' : '#565656'}
                            marginRight={14}
                            marginTop={5}
                            marginBottom={5}
                        />
                    ))}
                </div>
                <Text
                    label={'Horarios:'}
                    fontSize={16}
                    fontWeight={700}
                    color={'#565656'}
                    marginBottom={7}
                />
                <div className={styles.flexDirectionPayment} style={{ marginBottom: 15 }}>
                    <Text
                        label={`Desde: ${moment(
                            promotionInfo?.tInicio,
                            'HH:mm:ss'
                        ).format('HH:mm')}`}
                        fontSize={10}
                        fontWeight={700}
                        color={'#565656'}
                        marginRight={40}
                        marginBottom={10}
                    />
                    <Text
                        label={`Hasta: ${moment(
                            promotionInfo?.tTermino,
                            'HH:mm:ss'
                        ).format('HH:mm')}`}
                        fontSize={10}
                        fontWeight={600}
                        color={'#565656'}
                        marginBottom={10}
                    />
                </div>

                {btnCobrar && (<div className={styles.buttonContainerCenter}>
                    <button
                        className={styles.buttonReceive}
                        onClick={() => {
                            setShowPromotionModal(false)
                        }}
                        type="button"
                    >
                        <Text
                            label={'COBRAR'}
                            fontWeight={'bold'}
                            fontSize={15}
                            color="#fff"
                        />
                    </button>
                </div>)}
            </div>
        </ModalComponent>
    )
}

export default PromotionModal
